export default __webpack_public_path__ + "assets/location_big-56f88440e82a11906c71e90d7920008b.svg";